import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function LowerSpindleSpeedRow() {
   return (
      <InputRangeRow
         titleProp={"Lower Spindle Speed"}
         descriptionProp={"rpm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={1500}
         maxProp={8500}
         propertyNameProp={"speedLower"}
         errorDialogueProp={"1,500-8,500 only"}
         floatProp={false}
      />
   );
}
